/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 학교별 통계 탭
 * 버전 : 1.0
 * 파일명 : School_Analysis.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2026-01-30, 강동형 : 가드 추가
 * ================================================================*/

import { styled } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import DateRangePickerLegionExpose from './DateRangePickerLegionExpose'
import { SmallRoundToggleButton } from '../common/CommonStyled'
import { useAdAchiveStore } from 'src/stores/AdAchiveStore'
import InputBoxSearch from '../inputbox/InputBoxSearch'
import RegionSelectorAdminAchive from './RegionSelectorAdminAchive'
import { LoadSchoolAnalysis } from './useLoadSchoolAnalysis'
import School_AnalysisTable from './School_AnalysisTable'

const TapWrapper = styled('div')(({theme})=>({
  display:'flex',
  flexDirection:'column',

  position:'relative',
  height:'calc(100vh - 202px)',
  padding:'20px',
}))

const TapContainer = styled('div')(({theme})=>({
  display: 'flex',
  justifyContent:'space-between',
}))

const ToogleWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'flex-start',
    alignItems:'center',
    gap:'10px',
    marginTop:'20.5px',
    marginBottom:'10px'
}))

const School_Analysis = () => {
  const today = new Date();
  const prevMonth = new Date(today); // 오늘 날짜 복사
  prevMonth.setMonth(prevMonth.getMonth() - 1);
  const [periodOption,setPeriodOption] = useState<string | number>('1개월')
  const data = useAdAchiveStore((state)=>state.schoolAnalysisDate)
  const wide_Loc = useAdAchiveStore((state)=>state.wide_Loc)
  const city_Loc = useAdAchiveStore((state)=>state.city_Loc)
  const [start_date,setStart_date] = useState<string| null>(prevMonth.toISOString().slice(0, 10))
  const [end_date,setEnd_date] = useState<string| null>(today.toISOString().slice(0, 10))
  const [name,setName] = useState('')
  const setField = useAdAchiveStore((state)=>state.setField)
  const reset = useAdAchiveStore((state)=>state.reset)
  const [sort_by, setSort_by] = useState('')
  const [sort_order,setSort_order] = useState('asc')
  const [page,setPage] = useState<number>(1)
  const [pageSize] = useState(8)
  const [totalPage,setTotalPage] = useState(0)

  const searchParams = useMemo(() => ({
    sdate: start_date,
    edate: end_date,
    wideLoc: wide_Loc,
    cityLoc: city_Loc === '전체' ? '' : city_Loc,
    schoolName: name,
    sort_by,
    sort_order,
    page,
    size: pageSize,
  }), [start_date, end_date, wide_Loc, city_Loc, name, sort_by, sort_order, page, pageSize]);

  useEffect(()=>{
    return()=>{
      reset()
    }
  },[])  
  const fetch = async () => {
    const result = await LoadSchoolAnalysis(searchParams);
    setField('schoolAnalysisDate', result.data);
    setTotalPage(result.totalPage);
  };
  useEffect(() => {
  fetch();
}, [searchParams]);
  useEffect(()=>{
    const startDate = new Date(today); // today 복사
    if (periodOption === ''){
      return
    }
    if (periodOption === '1개월') {
      startDate.setMonth(today.getMonth() - 1);
    } else if (periodOption === '3개월') {
      startDate.setMonth(today.getMonth() - 3);
    } else if (periodOption === '6개월') {
      startDate.setMonth(today.getMonth() - 6);
    } else if (periodOption === '1년') {
      startDate.setFullYear(today.getFullYear() - 1);
    }
    setStart_date(startDate.toISOString().slice(0, 10))
    setEnd_date(today.toISOString().slice(0, 10))
  },[periodOption])
    return (
        <TapWrapper>
            <TapContainer>
              <DateRangePickerLegionExpose start_date={start_date} end_date={end_date} setStart_date={setStart_date} setEnd_date={setEnd_date} setPeriodOption={setPeriodOption}/>
              <div style={{flex:1, margin:'0px 10px'}}>
              <RegionSelectorAdminAchive setPage={setPage}/>
              </div>
              <div style={{width:'368px', height:'100%', color : '#C1C1C1'}}>
                <InputBoxSearch placeholder='학교명 검색' value={name} onChange={(e)=>setName(e.target.value)} onClick={()=>fetch()}></InputBoxSearch>
              </div>
            </TapContainer>
            <ToogleWrapper>
                <SmallRoundToggleButton $isSelected={periodOption==='1개월'} onClick={()=>setPeriodOption('1개월')}>1개월</SmallRoundToggleButton>
                <SmallRoundToggleButton $isSelected={periodOption==='3개월'} onClick={()=>setPeriodOption('3개월')}>3개월</SmallRoundToggleButton>
                <SmallRoundToggleButton $isSelected={periodOption==='6개월'} onClick={()=>setPeriodOption('6개월')}>6개월</SmallRoundToggleButton>
                <SmallRoundToggleButton $isSelected={periodOption==='1년'} onClick={()=>setPeriodOption('1년')}>1년</SmallRoundToggleButton>
            </ToogleWrapper>
            <School_AnalysisTable propsData={data ?? []} totalPage={totalPage} setPage={setPage} page={page} startdate={start_date} enddate={end_date} setSortBy={setSort_by} setSortOrder={setSort_order} sortBy={sort_by} sortOrder={sort_order}/>
        </TapWrapper>
    )
}

export default School_Analysis